import { Vue } from 'vue-property-decorator';
import axios from 'axios';
import { SPECIAL_DAYS_HELP, specialDayGroups } from './specialDayCalendar';

const API = process.env.VUE_APP_API_ADMIN_LOCATION + 'notification/';

export default Vue.extend({
  data: () => ({
    help: SPECIAL_DAYS_HELP,
    kinds: [],
    rows: [],
    isRangeOpen: false,
    rangeKind: null,
    rangeName: '',
    rangeStart: '',
    rangeEnd: '',
    dialogError: '',
    isShowSnackbar: false,
    snackbarLines: [],
  }),
  computed: {
    groups() {
      return specialDayGroups(this.kinds, this.rows);
    },
  },
  methods: {
    async refresh() {
      const [kinds, rows] = await Promise.all([axios.get(API + 'special-day-kinds'), axios.get(API + 'special-days')]);
      this.kinds = kinds.data.special_day_kinds;
      this.rows = rows.data.special_days;
    },
    errorMessage(err) {
      const { response } = err;
      return (response && response.data.error && response.data.error.message) || err.message;
    },
    addRange(group) {
      this.rangeKind = group;
      this.rangeName = '';
      this.rangeStart = '';
      this.rangeEnd = '';
      this.dialogError = '';
      this.isRangeOpen = true;
    },
    async saveRange() {
      this.dialogError = '';
      try {
        const { data } = await axios.post(API + 'special-days', {
          kind: this.rangeKind.kind,
          name: this.rangeName,
          start: this.rangeStart,
          end: this.rangeEnd || this.rangeStart,
        });
        this.isRangeOpen = false;
        this.snackbarLines = [
          `บันทึก ${data.days.length} วัน (${data.days[0]} ถึง ${data.days[data.days.length - 1]})`,
        ];
        this.isShowSnackbar = true;
        await this.refresh();
      } catch (err) {
        this.dialogError = this.errorMessage(err);
      }
    },
    async deleteRange(group, range) {
      const confirmed = await this.$root.$confirm(
        'Delete',
        `ลบ "${range.name}" (${group.label.th}) ${range.start} ถึง ${range.end}?`,
        { color: 'primary', submitText: 'Delete' }
      );
      if (!confirmed) {
        return;
      }
      try {
        await axios.delete(API + 'special-days', { params: { kind: group.kind, start: range.start, end: range.end } });
        await this.refresh();
      } catch (err) {
        this.snackbarLines = [this.errorMessage(err)];
        this.isShowSnackbar = true;
      }
    },
  },
  mounted() {
    this.refresh();
  },
});
